export const RECORDS_COLOR = '#357bff';
export const VOLUME_COLOR = '#357bff';
export const ERRORS_COLOR = '#e5484d';
